import { Container, Point, Sprite } from "pixi.js";
import { StealResourcePackage } from "../resources/StealResourcePackage";
import { gsap } from "gsap";

export class Girl extends Container {
    private readonly stealResources: StealResourcePackage;
    private forearmContainer: Container;
    private girlBody: Sprite;
    private girlForearm: Sprite;
    private flashlight: Sprite;

    public constructor(stealResources: StealResourcePackage) {
        super();
        this.stealResources = stealResources;
        this.build();
    }

    private build(): void {
        this.girlBody = new Sprite(this.stealResources.assets_views_steal_popup_girl_body_png);
        this.girlBody.anchor.set(0.5);
        this.addChild(this.girlBody);

        this.forearmContainer = new Container();
        this.addChild(this.forearmContainer);

        this.flashlight = new Sprite(this.stealResources.assets_views_steal_popup_wrist_flashlight_png);
        this.flashlight.anchor.set(0.5);
        this.flashlight.angle -= 80;
        this.forearmContainer.addChild(this.flashlight);

        this.girlForearm = new Sprite(this.stealResources.assets_views_steal_popup_forearm_png);
        this.girlForearm.anchor.set(0.5);
        this.forearmContainer.addChild(this.girlForearm);

        this.forearmContainer.pivot.set(11, 85);
        this.forearmContainer.position.set(this.girlBody.width * 0.5 - 103.5, this.girlBody.height * 0.5 - 663);
        this.flashlight.pivot.set(33, 47);
        this.flashlight.position.set(this.forearmContainer.width * 0.5 - 166, this.forearmContainer.height * 0.5 - 277.5);
    }

    public getStartAnimation(): gsap.core.Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.fromTo(this.forearmContainer, { angle: this.forearmContainer.angle },
            {
                angle: this.forearmContainer.angle + 20,
                duration: 0.15
            });
        animationTimeLine.fromTo(this.flashlight, { angle: this.flashlight.angle },
            {
                angle: this.flashlight.angle + 65,
                duration: 0.2
            }, "<");
        animationTimeLine.to(this.forearmContainer,
            {
                angle: this.forearmContainer.angle - 30,
                duration: 0.4
            }, "<95%");
        animationTimeLine.to(this.flashlight,
            {
                angle: this.flashlight.angle,
                duration: 0.17
            }, "<10%");
        animationTimeLine.then(() => animationTimeLine?.kill());
        return animationTimeLine;
    }

    public playHandAnimation(targetAngle: number): gsap.core.Timeline {
        const animationTimeLine = new gsap.core.Timeline();
        animationTimeLine.to(this.flashlight, { angle: this.flashlight.angle - targetAngle });
        animationTimeLine.then(() => animationTimeLine?.kill());
        return animationTimeLine;
    }

    public getFlashlightPosition(): Point {
        return this.flashlight.getGlobalPosition();
    }
}